import { useNavigate } from 'react-router-dom';
import { Button } from '@progress/kendo-react-buttons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { DashboardTileHeader } from '../../components/dashboard/dashboard-tile-header.tsx';
import { DashboardTileContent } from '../../components/dashboard/dashboard-tile-content.tsx';
import type { SamplingMetricsTileProps } from './sampling-metrics-tile.types.ts';
import { SamplingMetricsChart } from '../chart/sampling-metrics-chart.tsx';
import { SamplingJobChartType } from '../chart/sampling-metrics-chart.types.ts';
import { NoDataRender } from '../../components/render/no-data-render.tsx';
import styles from './sampling-metrics-tile.module.scss';

export function SamplingMetricsTile({ data }: SamplingMetricsTileProps) {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate('/sampling-metrics');
  };

  return (
    <>
      <DashboardTileHeader>
        Sampling Metrics
        <Button onClick={handleNavigate}>
          <FontAwesomeIcon icon={faArrowRight} size={'sm'} />
        </Button>
      </DashboardTileHeader>
      <DashboardTileContent className={styles.content}>
        {data.length === 0 ? (
          <NoDataRender message={'No sampling data available for today or upcoming dates.'} />
        ) : (
          <SamplingMetricsChart
            className={styles.chart}
            chartType={SamplingJobChartType.Sampler}
            interactive={false}
            data={data}
          />
        )}
      </DashboardTileContent>
    </>
  );
}
